import { remark } from 'remark';
import remarkSmartypants from './remarkSmartypants.js';
import remarkStringify from 'remark-stringify';

const processor = remark().use(remarkSmartypants).use(remarkStringify);

const memoCache = new Map();

export default function normalizeMarkdown(str: string) {
  str = str || '';

  const cached = memoCache.get(str);
  if (cached) return cached;

  // allow escaping dumb quotes with placeholder
  str = str.replace(/\\'/g, `~'~`);
  str = str.replace(/\\"/g, `~"~`);

  // replace hyphens between words with en dashes, unless there is a chance it is a code block
  if (!str.includes('`')) str = str.replaceAll(/(\S) +- +/g, '$1 \u2013 ');

  let o = (processor.processSync(str).value as string).trim();

  // restore dumb quotes
  o = o.replace(/~[‘’]~/g, `'`);
  o = o.replace(/~[“”]~/g, `"`);

  memoCache.set(str, o);

  return o;
}

try {
  window.normalizeMarkdown = normalizeMarkdown;
} catch (e) {}
